import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { BladeService } from '../../services/blade.service';


@Component({
    selector: 'app-blade-header',
    templateUrl: './blade-header.component.html',
    styleUrls: ['./blade-header.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BladeHeaderComponent {
    private readonly _bladeService = inject(BladeService);

    @Input() bladeIndex: number | undefined;

    @Output() closeClicked = new EventEmitter<void>();

    public get isVisible(): boolean {
        // Show if bladeIndex is not undefined or if closeClicked event has subscribers
        return this.bladeIndex !== undefined || this.closeClicked.observed;
    }

    public close() {
        if (this.bladeIndex !== undefined) {
            this._bladeService.closeBlade(this.bladeIndex);
        }

        this.closeClicked.next();
    }
}
